/* eslint-disable no-console */
import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
// import { initOnRamp } from '@coinbase/cbpay-js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal, message } from 'antd';
import { compose } from 'recompose';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connectAccount } from 'core';
// import coinbaseImg from 'assets/img/coinbase_pay.svg';
import buyCryptoWithFiatImg from 'assets/img/buy_crypto_banner.svg';
import closeImg from 'assets/img/close.png';

const ModalContent = styled.div`
  border-radius: 6px;
  padding: 27px 32px 23px 32px;
  color: white;
  gap: 25px;
  user-select: none;

  .close-btn {
    position: absolute;
    top: 30px;
    right: 32px;
  }

  .header {
    width: 100%;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .item {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;

    &:hover {
      transition: all 0.3s;
      color: rgba(39, 126, 230, 0.7);

      svg path {
        transition: all 0.3s;
        fill: rgba(39, 126, 230, 0.7);
      }
    }
  }

  .fiat-option {
    width: 100%;
    height: 212px;
    border-radius: 6px;
    border: 1px solid var(--color-text-secondary);
  }

  .disconnect-button {
    width: 100%;
    font-weight: 500;
    font-size: 18px;
    padding: 10px 0px;
    border-radius: 6px;
    border: 1px solid var(--color-text-secondary);
    text-align: center;
    cursor: pointer;
  }
`;

const StyledPaymentMethod = styled.div`
  margin: auto;
  width: 100%;
  position: relative;
`;

const StyledPayment = styled.div`
  margin: auto;
  width: 90%;
  height: 41px;
  border: 1px solid var(--color-text-secondary);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  cursor: pointer;
`;

const StyledPaymentSelect = styled.div`
  position: absolute;
  left: 50%;
  top: 45px;
  transform: translate(-50%, 0%);
  margin: auto;
  width: 90%;
  background: #eeeeee;
  color: black;
  border-radius: 6px;
`;

const StyledPaymentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: pointer;
  height: 40px;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &.active {
    background: #eeeeee;
  }
`;

const StyledName = styled.div`
  font-family: 'Inter-Medium';
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const useOutside = (ref, onClick) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClick]);
};

function AccountModal({ visible, onCancel, onDisconnect, settings, intl }) {
  // const onrampInstance = useRef();
  const [isReady, setIsReady] = useState(false);

  // const [paymentMethod, setPaymentMethod] = useState('');
  // const [openDropdown, setOpenDropdown] = useState(false);

  // const wrapperRef = useRef(null);
  // useOutside(wrapperRef, setOpenDropdown);

  const handleLink = () => {
    window.open(
      `${process.env.REACT_APP_ETH_EXPLORER}/address/${settings.selectedAddress}`,
      '_blank'
    );
  };

  return (
    <Modal
      id="info-modal"
      className="info-modal"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      closable={false}
      maskClosable
      centered
    >
      <ModalContent className="flex flex-column align-center just-center">
        <img
          className="close-btn pointer"
          src={closeImg}
          alt="close"
          onClick={onCancel}
        />

        <div className="header">
          <div className="flex">
            {settings.selectedAddress
              ? `${settings.selectedAddress.substr(
                  0,
                  6
                )}...${settings.selectedAddress.substr(
                  settings.selectedAddress.length - 4,
                  4
                )}`
              : ''}
          </div>

          <div
            className="item"
            onClick={() => {
              handleLink();
            }}
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.66667 0C0.755208 0 0 0.755208 0 1.66667V13.3333C0 14.2448 0.755208 15 1.66667 15H13.3333C14.2448 15 15 14.2448 15 13.3333V7.5H13.3333V13.3333H1.66667V1.66667H7.5V0H1.66667ZM9.16667 0V1.66667H12.1549L4.41081 9.41081L5.58919 10.5892L13.3333 2.84505V5.83333H15V0H9.16667Z"
                fill="white"
              />
            </svg>
          </div>

          <CopyToClipboard
            text={settings.selectedAddress}
            onCopy={() => {
              message.success(
                intl.formatMessage({
                  id: 'Copied_address'
                })
              );
            }}
          >
            <div className="item">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 0C0.670898 0 0 0.670898 0 1.5V12H1.5V1.5H12V0H1.5ZM4.5 3C3.6709 3 3 3.6709 3 4.5V13.5C3 14.3291 3.6709 15 4.5 15H13.5C14.3291 15 15 14.3291 15 13.5V4.5C15 3.6709 14.3291 3 13.5 3H4.5ZM4.5 4.5H13.5V13.5H4.5V4.5Z"
                  fill="white"
                />
              </svg>
            </div>
          </CopyToClipboard>
        </div>

        <div
          className="disconnect-button"
          onClick={() => {
            onDisconnect();
            onCancel();
          }}
        >
          <FormattedMessage id="Disconnect" />
        </div>
      </ModalContent>
    </Modal>
  );
}

AccountModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onDisconnect: PropTypes.func,
  settings: PropTypes.object,
  intl: intlShape.isRequired
};

AccountModal.defaultProps = {
  visible: false,
  settings: {},
  onCancel: () => {},
  onDisconnect: () => {}
};

const mapStateToProps = ({ account }) => ({
  settings: account.setting
});

export default injectIntl(
  compose(connectAccount(mapStateToProps, null))(AccountModal)
);
